import React from 'react'

const TableFilterField = props => <div className={props.className}>{props.children}</div>

export default TableFilterField
